import Vue from "vue"
import Vuex from "vuex"
import VuexPersit from "vuex-persist"
import localForage from "localforage"

Vue.use(Vuex)
import symtomchecker from "./SymtomChecker/index"
import auth from "./auth/index"
import pet from "./pet/index"

const vuexStorage = new VuexPersit({
  key: process.env.VUE_APP_STORAGE_KEY,
  storage: localForage,
})

const store = new Vuex.Store({
  plugins: [vuexStorage.plugin],
  modules: {
    sc: symtomchecker,
    auth: auth,
    pet: pet,
  },
  state: {
    count: 1,
  },
  mutations: {
    initialiseStore(state) {
      if (localStorage.getItem("store")) {
        this.replaceState(
          Object.assign(state, JSON.parse(localStorage.getItem("store")))
        )
      }
    },
    increment(state) {
      state.count++
    },
  },
})

store.subscribe((mutation, state) => {
  localStorage.setItem("store", JSON.stringify(state))
})

export default store
